import { EActionState, IProxyPhoneDto } from '@/models';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';

export const proxyPhonesSlice = createSlice({
	name: '@@proxyPhones',
	initialState,
	reducers: {
		LOAD_PROXY_PHONES_START: state => {
			state.loaded = EActionState.RUNNING;
		},
		LOAD_PROXY_PHONES_COMPLETED: (
			state,
			action: PayloadAction<IProxyPhoneDto[]>
		) => {
			state.data = action.payload;
			state.loaded = EActionState.COMPLETED;
		},
		LOAD_PROXY_PHONES_FAILED: state => {
			state.data = initialState.data;
			state.loaded = EActionState.FAILED;
		},
		SYNC_PROXY_PHONES_START: (state, action: PayloadAction<string>) => {
			void action.payload;
			state.syncing = EActionState.RUNNING;
		},
		SYNC_PROXY_PHONES_COMPLETED: state => {
			state.syncing = EActionState.COMPLETED;
		},
		SYNC_PROXY_PHONES_FAILED: state => {
			state.syncing = EActionState.FAILED;
		},
		UNLOCK_PROXY_PHONE_START: (state, action: PayloadAction<string>) => {
			void action.payload;
			state.unlocking = EActionState.RUNNING;
		},
		UNLOCK_PROXY_PHONE_COMPLETED: (
			state,
			action: PayloadAction<string>
		) => {
			const proxyPhone = action.payload;
			const matched = state.data.find(
				item => item.proxyPhone === proxyPhone
			);

			if (matched) {
				matched.locked = false;
				matched.lockedUntil = null;
			}

			state.unlocking = EActionState.COMPLETED;
		},
		UNLOCK_PROXY_PHONE_FAILED: state => {
			state.unlocking = EActionState.FAILED;
		},
		SET_COMPANY_FILTER: (state, action: PayloadAction<string>) => {
			state.companyFilter = action.payload;
		},
		SET_OWNER_FILTER: (state, action: PayloadAction<string>) => {
			state.ownerFilter = action.payload;
		}
	}
});

export const actionCreator = proxyPhonesSlice.actions;
export const reducer = proxyPhonesSlice.reducer;
